module.exports = __webpack_public_path__ + "img/Flag_of_Mozambique.bc33186e.svg";